"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 * @since 1.0.0
 */
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var FormResolverService = /** @class */ (function () {
    function FormResolverService(router) {
        this.router = router;
    }
    FormResolverService_1 = FormResolverService;
    /**
     * Navigates to create new dynamic data-entry form.
     *
     * Returns a promise that:
     * - resolves to 'true' when navigation succeeds,
     * - resolves to 'false' when navigation fails,
     * - is rejected when an error happens.
     *
     * @param {string} categorySystemName
     * @param {string} formName
     * @param {number} [formId=0]
     * @param {object} queryParams
     * @returns {Promise<boolean>}
     */
    FormResolverService.prototype.navigateToCreateNewDeForm = function (categorySystemName, formName, formId, queryParams) {
        if (!formId) {
            formId = 0;
        }
        return this.navigateToDynamicDeForm(categorySystemName, formName, formId, undefined, queryParams, '');
    };
    /**
     * Navigates to editable dynamic data-entry form.
     *
     * Returns a promise that:
     * - resolves to 'true' when navigation succeeds,
     * - resolves to 'false' when navigation fails,
     * - is rejected when an error happens.
     *
     * @param {string} categorySystemName
     * @param {string} formName
     * @param {number} instanceId
     * @param {number} [formId=0]
     * @param {string} tabId
     * @param {object} queryParams
     * @returns {Promise<boolean>}
     */
    FormResolverService.prototype.navigateToEditDeForm = function (categorySystemName, formName, instanceId, formId, queryParams, tabId) {
        if (!formId) {
            formId = 0;
        }
        return this.navigateToDynamicDeForm(categorySystemName, formName, formId, instanceId, queryParams, tabId);
    };
    /**
     * Navigates to dynamic view data-entry form.
     *
     * Returns a promise that:
     * - resolves to 'true' when navigation succeeds,
     * - resolves to 'false' when navigation fails,
     * - is rejected when an error happens.
     *
     * @param {string} categorySystemName
     * @param {string} formName
     * @param {number} instanceId
     * @param {number} [formId=0]
     * @param {string} tabId
     * @param {object} queryParams
     * @returns {Promise<boolean>}
     */
    FormResolverService.prototype.navigateToViewDeForm = function (categorySystemName, formName, instanceId, formId, queryParams, tabId) {
        if (!formId) {
            formId = 0;
        }
        return this.navigateToDynamicDeForm(categorySystemName, formName, formId, instanceId, queryParams, tabId);
    };
    /**
     * Creates navigation url for create new dynamic de forms.
     * @param {string} categorySystemName
     * @param {string} formName
     * @param {number} [formId=0]
     * @param {object} queryParams
     * @returns {Promise<string>}
     */
    FormResolverService.prototype.getUrlForCreateNewDeForm = function (categorySystemName, formName, formId, queryParams) {
        if (!formId) {
            formId = 0;
        }
        return this.getUrlForDynamicForm(categorySystemName, formName, formId, undefined, queryParams);
    };
    /**
     * Creates navigation url for edit dynamic de forms.
     * @param {string} categorySystemName
     * @param {string} formName
     * @param {number} instanceId
     * @param {number} [formId=0]
     * @param {object} queryParams
     * @returns {Promise<string>}
     */
    FormResolverService.prototype.getUrlForEditDeForm = function (categorySystemName, formName, instanceId, formId, queryParams) {
        if (!formId) {
            formId = 0;
        }
        return this.getUrlForDynamicForm(categorySystemName, formName, formId, instanceId, queryParams);
    };
    /**
     * Creates navigation url for view dynamic de forms.
     * @param {string} categorySystemName
     * @param {string} formName
     * @param {number} instanceId
     * @param {number} [formId=0]
     * @param {object} queryParams
     * @returns {Promise<string>}
     */
    FormResolverService.prototype.getUrlForViewDeForm = function (categorySystemName, formName, instanceId, formId, queryParams) {
        if (!formId) {
            formId = 0;
        }
        return this.getUrlForDynamicForm(categorySystemName, formName, formId, instanceId, queryParams);
    };
    FormResolverService.prototype.getUrlForCreateNewDeFormSync = function (categorySystemName, formName, formId, queryParams) {
        if (!formId) {
            formId = 0;
        }
        return this.getUrlForDynamicFormSync(categorySystemName, formName, formId, undefined, queryParams);
    };
    FormResolverService.prototype.getUrlForEditDeFormSync = function (categorySystemName, formName, instanceId, formId, queryParams) {
        if (!formId) {
            formId = 0;
        }
        return this.getUrlForDynamicFormSync(categorySystemName, formName, formId, instanceId, queryParams);
    };
    FormResolverService.prototype.getUrlForViewDeFormSync = function (categorySystemName, formName, instanceId, formId, queryParams) {
        if (!formId) {
            formId = 0;
        }
        return this.getUrlForDynamicFormSync(categorySystemName, formName, formId, instanceId, queryParams);
    };
    FormResolverService.prototype.navigateToDynamicDeForm = function (categorySystemName, formName, formId, instanceId, queryParams, tabId) {
        return !instanceId
            ? this.router.navigate([
                this.resolvePrefixForNavigation(),
                FormResolverService_1.TO_DATA_ENTRY_ROUTE,
                categorySystemName,
                formName,
                formId,
            ], {
                queryParams: queryParams,
                fragment: tabId,
            })
            : this.router.navigate([
                this.resolvePrefixForNavigation(),
                FormResolverService_1.TO_DATA_ENTRY_ROUTE,
                categorySystemName,
                formName,
                formId,
                instanceId,
            ], {
                queryParams: queryParams,
                fragment: tabId,
            });
    };
    FormResolverService.prototype.getUrlForDynamicForm = function (categorySystemName, formName, formId, instanceId, queryParams) {
        return Promise.resolve(this.getUrlForDynamicFormSync(categorySystemName, formName, formId, instanceId, queryParams));
    };
    FormResolverService.prototype.getUrlForDynamicFormSync = function (categorySystemName, formName, formId, instanceId, queryParams) {
        var result = instanceId
            ?
                FormResolverService_1.TO_DATA_ENTRY_ROUTE + "/" + categorySystemName + "/" + formName + "/" + formId + "/" + instanceId
            : FormResolverService_1.TO_DATA_ENTRY_ROUTE + "/" + categorySystemName + "/" + formName + "/" + formId;
        if (queryParams) {
            var params = [];
            for (var param in queryParams) {
                if (queryParams.hasOwnProperty(param)) {
                    params.push(param + "=" + queryParams[param]);
                }
            }
            result = result + "?" + params.join('&');
        }
        return result;
    };
    FormResolverService.prototype.resolvePrefixForNavigation = function () {
        var url = this.router.url;
        return url.includes(FormResolverService_1.TO_DATA_ENTRY_ROUTE) ?
            url.split(FormResolverService_1.TO_DATA_ENTRY_ROUTE)[0] : '';
    };
    /**
     * Used for navigating to data entry form.
     * @type {string}
     * @default
     * @static
     * @readonly
     * @private
     */
    FormResolverService.TO_DATA_ENTRY_ROUTE = 'dynamic-de';
    FormResolverService = FormResolverService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [router_1.Router])
    ], FormResolverService);
    return FormResolverService;
    var FormResolverService_1;
}());
exports.FormResolverService = FormResolverService;
//# sourceMappingURL=form-resolver.service.js.map